export enum ApplicationCode {
  AWD = 'AWD',
  AWP = 'AWP',
  AWZ = 'AWZ',
  ZS_1 = 'ZS_1',
  ZS_2 = 'ZS_2',
  ZS_3 = 'ZS_3',
  ZS_4 = 'ZS_4',
  ZS_6 = 'ZS_6',
  DS_R = 'DS_R',
  DS_U = 'DS_U',
  NSR_5 = 'NSR_5',
  SR_1 = 'SR_1',
  SR_2 = 'SR_2',
  SR_3 = 'SR_3',
  SR_4 = 'SR_4',
  SR_5 = 'SR_5',
  SR_7 = 'SR_7',
  SR_8 = 'SR_8',
  KDR = 'KDR',
  SW_R = 'SW_R',
  SW_U = 'SW_U',
  PPW = 'PPW',
  SWN = 'SWN',
  FA_1 = 'FA_1',
  PS_1 = 'PS_1',
  PS_2 = 'PS_2',
  PS_3 = 'PS_3',
  PS_U = 'PS_U',
  RKZ_1 = 'RKZ_1',
  RKZ_2 = 'RKZ_2',
  RKZ_3 = 'RKZ_3',
  RKZ_4 = 'RKZ_4',
  RKZ_5 = 'RKZ_5',
  RKZ_6 = 'RKZ_6',
  RKZ_7 = 'RKZ_7',
  RKZ_8 = 'RKZ_8',
  ON_1 = 'ON_1',
  ON_2 = 'ON_2',
  RKO_U = 'RKO_U',
  RKO_R = 'RKO_R',
  DZ_R = 'DZ_R',
}

export const APPLICATION_CODE_LABELS: Record<ApplicationCode, string> = {
  AWD: 'AWD - Wniosek o świadczenie Aktywnie w domu',
  AWP: 'AWP - Wniosek o świadczenie Aktywni rodzice w pracy',
  AWZ: 'AWZ - Wniosek o świadczenie Aktywnie w żłobku',
  ZS_1: 'ZS-1 - Wniosek o wydanie zaświadczenia o udzielonej pomocy',
  ZS_2: 'ZS-2 - Wniosek o umorzenie należności (...)',
  ZS_3: 'ZS-3 - Zgłoszenie nieprawidłowości do jednostki terenowej',
  ZS_4: 'ZS-4 - Wniosek o zmianę decyzji lub postanowienia',
  ZS_6: 'ZS-6 - Koresponduj w sprawie',
  DS_R: 'DS-R - Wniosek o ustalenie prawa do świadczenia dobry start',
  DS_U: 'DS-U - Wniosek o ustalenie prawa do świadczenia dobry start dla obywateli Ukrainy',
  NSR_5:
    'NSR-5 - Wniosek o ustalenie prawa do świadczenia pielęgnacyjnego (...)',
  SR_1: 'SR-1 - Wniosek o ustalenie prawa do zasiłku rodzinnego (...)',
  SR_2: 'SR-2 - Wniosek o ustalenie prawa do jednorazowej zapomogi (...)',
  SR_3: 'SR-3 - Wniosek o ustalenie prawa do zasiłku pielęgnacyjnego',
  SR_4: 'SR-4 - Wniosek o ustalenie prawa do specjalnego zasiłku opiekuńczego',
  SR_5: 'SR-5 - Wniosek o ustalenie prawa do świadczenia pielęgnacyjnego (...)',
  SR_7: 'SR-7 - Wniosek o ustalenie prawa do świadczenia rodzicielskiego',
  SR_8: 'SR-8 - Wniosek o ustalenie prawa do jednorazowego świadczenia (...)',
  KDR: 'KDR - Wniosek o ustalenie prawa do Ogólnopolskiej Karty Dużej Rodziny (...)',
  SW_R: 'SW-R - Wniosek o świadczenie wychowawcze 800+ (...)',
  SW_U: 'SW-U - Wniosek o świadczenie wychowawcze 800+ (...)',
  PPW: 'PPW - Wniosek o wydanie decyzji ustalającej poziom potrzeby wsparcia',
  SWN: 'SWN - Wniosek o świadczenie wspierające',
  FA_1: 'FA-1 - Wniosek o ustalenie prawa do świadczeń z funduszu alimentacyjnego',
  PS_1: 'PS-1 - Wniosek o przyznanie pomocy społecznej',
  PS_2: 'PS-2 - Powiadomienie o zmianie sytuacji życiowej',
  PS_3: 'PS-3 - Informacja o potrzebie przyznania pomocy społecznej (...)',
  PS_U: 'PS-U - Pomoc jednorazowa dla obywateli Ukrainy (...)',
  RKZ_1: 'RKZ-1 - Wniosek o wpis do rejestru żłobków (...)',
  RKZ_2: 'RKZ-2 - Informacja o zmianie danych (...)',
  RKZ_3: 'RKZ-3 - Wniosek o wykreślenie z rejestru żłobków (...)',
  RKZ_4: 'RKZ-4 - Sprawozdanie z działalności żłobków (...)',
  RKZ_5: 'RKZ-5 - Informacja o dzieciach uczęszczających (...)',
  RKZ_6: 'RKZ-6 - Wniosek dla podmiotów innych niż gmina (...)',
  RKZ_7: 'RKZ-7 - Oświadczenie dla podmiotów innych niż gmina (...)',
  RKZ_8: 'RKZ-8 - Informacja o standardach opieki',
  ON_1: 'ON-1 - Wniosek o wpis do rejestru organizatorów (...)',
  ON_2: 'ON-2 - Wniosek o wpis do rejestru ośrodków (...)',
  RKO_U: 'RKO-U - Wniosek o Rodzinny Kapitał Opiekuńczy dla obywateli Ukrainy',
  RKO_R:
    'RKO-R - Wniosek o Rodzinny Kapitał Opiekuńczy (dla matki lub ojca dziecka)',
  DZ_R: 'DZ-R - Wniosek o dofinansowanie obniżenia opłaty za pobyt dziecka w żłobku (...)',
};

export const BENEFICIARY_CODES: ApplicationCode[] = [
  ApplicationCode.AWD,
  ApplicationCode.AWP,
  ApplicationCode.AWZ,
  ApplicationCode.ZS_1,
  ApplicationCode.ZS_2,
  ApplicationCode.ZS_3,
  ApplicationCode.ZS_4,
  ApplicationCode.ZS_6,
  ApplicationCode.DS_R,
  ApplicationCode.DS_U,
  ApplicationCode.NSR_5,
  ApplicationCode.SR_1,
  ApplicationCode.SR_2,
  ApplicationCode.SR_3,
  ApplicationCode.SR_4,
  ApplicationCode.SR_5,
  ApplicationCode.SR_7,
  ApplicationCode.SR_8,
  ApplicationCode.KDR,
  ApplicationCode.SW_R,
  ApplicationCode.SW_U,
  ApplicationCode.PPW,
  ApplicationCode.SWN,
  ApplicationCode.FA_1,
  ApplicationCode.PS_1,
  ApplicationCode.PS_2,
  ApplicationCode.PS_3,
  ApplicationCode.PS_U,
  ApplicationCode.RKZ_1,
  ApplicationCode.RKZ_2,
  ApplicationCode.RKZ_6,
  ApplicationCode.RKZ_7,
  ApplicationCode.ON_1,
  ApplicationCode.ON_2,
];

export const ORGANIZATION_CODES: ApplicationCode[] = [
  ApplicationCode.RKZ_1,
  ApplicationCode.RKZ_2,
  ApplicationCode.RKZ_3,
  ApplicationCode.RKZ_4,
  ApplicationCode.RKZ_5,
  ApplicationCode.RKZ_6,
  ApplicationCode.RKZ_7,
  ApplicationCode.RKZ_8,
  ApplicationCode.ON_1,
  ApplicationCode.ON_2,
];

export const ORGANIZATION_EXCLUSIVE_CODES: ApplicationCode[] = [
  ApplicationCode.RKZ_3,
  ApplicationCode.RKZ_4,
  ApplicationCode.RKZ_5,
  ApplicationCode.RKZ_8,
];

export const IS_ZUS_APPLICATION: ApplicationCode[] = [
  ApplicationCode.DS_R,
  ApplicationCode.DS_U,
  ApplicationCode.SW_R,
  ApplicationCode.SW_U,
  ApplicationCode.SWN,
  ApplicationCode.AWZ,
  ApplicationCode.AWP,
  ApplicationCode.AWD,
  ApplicationCode.RKO_R,
  ApplicationCode.RKO_U,
  ApplicationCode.DZ_R,
];

export function getApplicationCodeDropdown(codes: ApplicationCode[]) {
  return codes.map((code) => ({
    value: code,
    label: APPLICATION_CODE_LABELS[code],
  }));
}

export function getApplicationCodeDropdownValueByContext(
  isOrganization: boolean,
) {
  return getApplicationCodeDropdown(
    isOrganization ? ORGANIZATION_CODES : BENEFICIARY_CODES,
  );
}
